import TruncatedTextSystem from './TruncatedTextSystem';
import './TruncatedTextSystem.scss';

export default TruncatedTextSystem;
